import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Spinner de carga que NO ocupa espacio en el layout: se dibuja en `absolute` sobre el
 * contenido, así que aparecer o desaparecer no mueve nada.
 *
 * Tiene que colgar de un contenedor con `position: relative`. En los modales de ABM ese
 * contenedor es la `.column` de `styles/pages/ModalActions.module.scss`, que ya lo trae.
 *
 * Existe aparte de `CircularIndeterminate` porque ese se usa EN EL FLUJO a propósito
 * (organigrama, listados, y los modales que hacen `isLoading ? <spinner/> : <form/>`),
 * donde el spinner ES el contenido mientras carga.
 */
export default function SpinnerOverlay() {
    return (
        <div
            style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // Velo tenue sobre el formulario: se lee que está bloqueado sin taparlo.
                // El paper del modal es blanco fijo, así que el blanco es consistente.
                backgroundColor: "rgba(255, 255, 255, 0.55)",
                zIndex: 2,
            }}
        >
            <CircularProgress />
        </div>
    );
}
